import { useCallback } from 'react';
import { useModals } from '@customerio/pluma-components/react';
import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';
import {
  AddonPurchaseModal,
  type AddonPurchaseModalData,
  type AddonPurchaseResult,
} from '../components/addon-purchase-modal';

export type AddonPurchase = {
  canPurchase: boolean;
  openAddon: (data: AddonPurchaseModalData) => Promise<AddonPurchaseResult | null>;
};

export function useAddonPurchase(): AddonPurchase {
  const { account } = useAuth();
  const modals = useModals();
  const canPurchase = isFlexPlan(account);

  const openAddon = useCallback(
    async (data: AddonPurchaseModalData) => {
      if (!canPurchase) return null;
      const modalId = modals.open(AddonPurchaseModal, data, { shouldCloseOnUnmount: true });
      const result = await modals.waitForClose(modalId);
      return result.reason === 'confirm' ? (result.data ?? null) : null;
    },
    [canPurchase, modals],
  );

  return { canPurchase, openAddon };
}
